module.exports = __webpack_public_path__ + "img/logo-4.5e2a8f5b.png";